module.exports = __webpack_public_path__ + "img/section_img9.511e5fad.png";